'use client';

import { c as _c } from "react/compiler-runtime";
import type { ListQueryCodeApiDto } from '__generated__/api/unauth/types.gen';
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import type { FilterOption } from '../../constants';
import { FilterCheckboxList } from '../FilterCheckboxList';
import { FilterChipGroup } from '../FilterChipGroup';
import { FilterDrawerShell } from '../FilterDrawerShell';
import { FilterSection } from '../FilterSection';
import { FilterSidebarShell } from '../FilterSidebarShell';
interface PolicyFilterProps {
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
  onApplyDrawer: () => void;
  targetCodes: string[];
  provisionCodes: string[];
  jobCodes: string[];
  ageCodes: string[];
  onToggleTargetCode: (code: string) => void;
  onToggleProvisionCode: (code: string) => void;
  onToggleJobCode: (code: string) => void;
  onToggleAgeCode: (code: string) => void;
  onReset: () => void;
}
const toFilterOptions = (codes?: Array<ListQueryCodeApiDto>): FilterOption<string>[] => (codes ?? []).filter((item): item is Required<Pick<ListQueryCodeApiDto, 'code' | 'value'>> => Boolean(item.code && item.value)).map(item => ({
  value: item.code,
  label: item.value
}));
export function PolicyFilter(t0) {
  const $ = _c(74);
  const {
    isDrawerOpen,
    onCloseDrawer,
    onApplyDrawer,
    targetCodes,
    provisionCodes,
    jobCodes,
    ageCodes,
    onToggleTargetCode,
    onToggleProvisionCode,
    onToggleJobCode,
    onToggleAgeCode,
    onReset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/query/policies/codes/target"](),
      select: _temp
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: t2,
    isLoading: isTargetLoading
  } = useQuery(t1);
  let t3;
  if ($[1] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const targetOptions = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/query/policies/codes/provision"](),
      select: _temp2
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    data: t5,
    isLoading: isProvisionLoading
  } = useQuery(t4);
  let t6;
  if ($[4] !== t5) {
    t6 = t5 === undefined ? [] : t5;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const provisionOptions = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/query/policies/codes/job"](),
      select: _temp3
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const {
    data: t8,
    isLoading: isJobLoading
  } = useQuery(t7);
  let t9;
  if ($[7] !== t8) {
    t9 = t8 === undefined ? [] : t8;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const jobOptions = t9;
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/query/policies/codes/age"](),
      select: _temp4
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const {
    data: t11,
    isLoading: isAgeLoading
  } = useQuery(t10);
  let t12;
  if ($[10] !== t11) {
    t12 = t11 === undefined ? [] : t11;
    $[10] = t11;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const ageOptions = t12;
  let t13;
  if ($[12] !== isTargetLoading || $[13] !== onToggleTargetCode || $[14] !== targetCodes || $[15] !== targetOptions) {
    t13 = <FilterSection title={"\uB300\uC0C1"}><FilterCheckboxList options={targetOptions} selectedValues={targetCodes} onToggle={onToggleTargetCode} isLoading={isTargetLoading} skeletonCount={6} /></FilterSection>;
    $[12] = isTargetLoading;
    $[13] = onToggleTargetCode;
    $[14] = targetCodes;
    $[15] = targetOptions;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== isProvisionLoading || $[18] !== onToggleProvisionCode || $[19] !== provisionCodes || $[20] !== provisionOptions) {
    t14 = <FilterSection title={"\uC9C0\uC6D0\uD615\uD0DC"}><FilterCheckboxList options={provisionOptions} selectedValues={provisionCodes} onToggle={onToggleProvisionCode} isLoading={isProvisionLoading} skeletonCount={6} /></FilterSection>;
    $[17] = isProvisionLoading;
    $[18] = onToggleProvisionCode;
    $[19] = provisionCodes;
    $[20] = provisionOptions;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== isJobLoading || $[23] !== jobCodes || $[24] !== jobOptions || $[25] !== onToggleJobCode) {
    t15 = <FilterSection title={"\uC9C1\uC5C5"}><FilterCheckboxList options={jobOptions} selectedValues={jobCodes} onToggle={onToggleJobCode} isLoading={isJobLoading} skeletonCount={6} /></FilterSection>;
    $[22] = isJobLoading;
    $[23] = jobCodes;
    $[24] = jobOptions;
    $[25] = onToggleJobCode;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== ageCodes || $[28] !== ageOptions || $[29] !== isAgeLoading || $[30] !== onToggleAgeCode) {
    t16 = <FilterSection title={"\uC5F0\uB839"}><FilterCheckboxList options={ageOptions} selectedValues={ageCodes} onToggle={onToggleAgeCode} isLoading={isAgeLoading} skeletonCount={6} /></FilterSection>;
    $[27] = ageCodes;
    $[28] = ageOptions;
    $[29] = isAgeLoading;
    $[30] = onToggleAgeCode;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== onReset || $[33] !== t13 || $[34] !== t14 || $[35] !== t15 || $[36] !== t16) {
    t17 = <FilterSidebarShell onReset={onReset}>{t13}{t14}{t15}{t16}</FilterSidebarShell>;
    $[32] = onReset;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <h3 className="font-700 text-Gray-900 typo-body4">대상</h3>;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== isTargetLoading || $[40] !== onToggleTargetCode || $[41] !== targetCodes || $[42] !== targetOptions) {
    t19 = <div className="flex flex-col gap-12">{t18}<FilterChipGroup options={targetOptions} selectedValues={targetCodes} onToggle={onToggleTargetCode} isLoading={isTargetLoading} skeletonCount={6} /></div>;
    $[39] = isTargetLoading;
    $[40] = onToggleTargetCode;
    $[41] = targetCodes;
    $[42] = targetOptions;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <h3 className="font-700 text-Gray-900 typo-body4">지원형태</h3>;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== isProvisionLoading || $[46] !== onToggleProvisionCode || $[47] !== provisionCodes || $[48] !== provisionOptions) {
    t21 = <div className="flex flex-col gap-12">{t20}<FilterChipGroup options={provisionOptions} selectedValues={provisionCodes} onToggle={onToggleProvisionCode} isLoading={isProvisionLoading} skeletonCount={6} /></div>;
    $[45] = isProvisionLoading;
    $[46] = onToggleProvisionCode;
    $[47] = provisionCodes;
    $[48] = provisionOptions;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <h3 className="font-700 text-Gray-900 typo-body4">직업</h3>;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== isJobLoading || $[52] !== jobCodes || $[53] !== jobOptions || $[54] !== onToggleJobCode) {
    t23 = <div className="flex flex-col gap-12">{t22}<FilterChipGroup options={jobOptions} selectedValues={jobCodes} onToggle={onToggleJobCode} isLoading={isJobLoading} skeletonCount={6} /></div>;
    $[51] = isJobLoading;
    $[52] = jobCodes;
    $[53] = jobOptions;
    $[54] = onToggleJobCode;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <h3 className="font-700 text-Gray-900 typo-body4">연령</h3>;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== ageCodes || $[58] !== ageOptions || $[59] !== isAgeLoading || $[60] !== onToggleAgeCode) {
    t25 = <div className="flex flex-col gap-12">{t24}<FilterChipGroup options={ageOptions} selectedValues={ageCodes} onToggle={onToggleAgeCode} isLoading={isAgeLoading} skeletonCount={6} /></div>;
    $[57] = ageCodes;
    $[58] = ageOptions;
    $[59] = isAgeLoading;
    $[60] = onToggleAgeCode;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== isDrawerOpen || $[63] !== onApplyDrawer || $[64] !== onCloseDrawer || $[65] !== onReset || $[66] !== t19 || $[67] !== t21 || $[68] !== t23 || $[69] !== t25) {
    t26 = <FilterDrawerShell isOpen={isDrawerOpen} onReset={onReset} onApply={onApplyDrawer} onClose={onCloseDrawer}>{t19}{t21}{t23}{t25}</FilterDrawerShell>;
    $[62] = isDrawerOpen;
    $[63] = onApplyDrawer;
    $[64] = onCloseDrawer;
    $[65] = onReset;
    $[66] = t19;
    $[67] = t21;
    $[68] = t23;
    $[69] = t25;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  let t27;
  if ($[71] !== t17 || $[72] !== t26) {
    t27 = <>{t17}{t26}</>;
    $[71] = t17;
    $[72] = t26;
    $[73] = t27;
  } else {
    t27 = $[73];
  }
  return t27;
}
function _temp4(data_2) {
  return toFilterOptions(data_2.context?.queryCodes);
}
function _temp3(data_1) {
  return toFilterOptions(data_1.context?.queryCodes);
}
function _temp2(data_0) {
  return toFilterOptions(data_0.context?.queryCodes);
}
function _temp(data) {
  return toFilterOptions(data.context?.queryCodes);
}